var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg877MillionNormalstage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5846 71.2615C74.5846 74.9316 62.6806 77.9076 48 77.9076C33.3194 77.9076 21.4154 74.9316 21.4154 71.2615",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 14.7691C62.6823 14.7691 74.5846 11.7935 74.5846 8.12296C74.5846 4.45239 62.6823 1.47681 48 1.47681C33.3177 1.47681 21.4154 4.45239 21.4154 8.12296C21.4154 11.7935 33.3177 14.7691 48 14.7691Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5846 87.8767C74.5846 91.5469 62.6806 94.5229 48 94.5229C33.3194 94.5229 21.4154 91.5469 21.4154 87.8767",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4154 8.12305V87.8769",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5846 8.12305V87.8769",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 87.8768C48.9177 87.8768 49.6616 87.1329 49.6616 86.2152C49.6616 85.2976 48.9177 84.5537 48 84.5537C47.0824 84.5537 46.3385 85.2976 46.3385 86.2152C46.3385 87.1329 47.0824 87.8768 48 87.8768Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6154 43.0154C64.6154 52.176 57.1606 59.6308 48 59.6308C38.8394 59.6308 31.3846 52.176 31.3846 43.0154",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 52.9846C42.4948 52.9846 38.0308 48.5206 38.0308 43.0154V33.0461C38.0308 27.5409 42.4948 23.0769 48 23.0769C53.5052 23.0769 57.9692 27.5409 57.9692 33.0461V43.0154C57.9692 48.5206 53.5052 52.9846 48 52.9846Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 59.6306V69.5998",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7693 44.6768V51.3229",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12305 40.5229V55.4768",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47693 43.8459V52.1536",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2307 44.6768V51.3229",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8768 40.5229V55.4768",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5231 43.8459V52.1536",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg877MillionNormalstage);
export default __webpack_public_path__ + "static/media/87-7Million_Normalstage.aef2f2343084198c03ff1fc34fe1501c.svg";
export { ForwardRef as ReactComponent };